"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanRecordRequest = void 0;
var LoanRecordRequest = /** @class */ (function () {
    function LoanRecordRequest() {
    }
    return LoanRecordRequest;
}());
exports.LoanRecordRequest = LoanRecordRequest;
;
//# sourceMappingURL=loanRecord.request.js.map